import styled from 'styled-components';
import {typographyStyles} from '../../utils/styles';

const StyledOverflowProgressWrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;

  .ant-progress {
    height: 6px;
    display: flex;
  }
`;

const StyledOverflowProgressContent = styled.div`
  position: relative;
  width: 100%;
`;

const StyledOverflowProgressOverlay = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  height: 6px;
  pointer-events: none;
  transition: width 200ms ease;
  z-index: 2;
`;

const StyledOverflowProgressText = styled.span`
  ${typographyStyles.body.regular};
  color: ${props => props.color || props.theme.colors.neutral_10};
  margin-left: 16px;
  text-align: left;
  min-width: 30px;
  text-wrap: nowrap;
`;

export {
  StyledOverflowProgressWrapper,
  StyledOverflowProgressContent,
  StyledOverflowProgressOverlay,
  StyledOverflowProgressText
}
